import ApiRequest from "../utils/ApiRequest";
import apiConfig from "../utils/ApiConfig";

export default class Grant {
  static getAll = async () => {
    return await ApiRequest.set("v1/grants/get-all", "GET");
  }

  static searchByStatusAndPagination = async ( keyword, limit, page, status) => {
    return await ApiRequest.set(`v1/grants/search-by-status-with-pagination?keyword=${keyword}&limit=${limit}&page=${page}&status=${status}`, "GET");
  } 

  static getById = async (id) => {
    return await ApiRequest.set(`v1/grants/get-by-id/${id}`, "GET");
  }

  static getViewUrlById = (id, type) => {
    return `${apiConfig.base_url}v1/grants/view-pdf-by-id/${id}?type=${type}`;
  }

  static approveGrant = async (id) => {
    return await ApiRequest.set(`v1/grants/approve-grant-by-id/${id}`, "PUT");
  }

  static rejectGrant = async (id, body) => {
    return await ApiRequest.set(`v1/grants/reject-grant-by-id/${id}`, "PUT", body);
  }

  static approveGrantDocument = async (id) => {
    return await ApiRequest.set(`v1/grants/approve-grant-document-by-id/${id}`, "PUT");
  }

  static rejectGrantDocument = async (id, body) => {
    return await ApiRequest.set(`v1/grants/reject-grant-document-by-id/${id}`, "PUT", body);
  }

  static approveGrantPayment = async (id) => {
    return await ApiRequest.set(`v1/grants/approve-grant-payment-by-id/${id}`, "PUT");
  }

  static rejectGrantPayment = async (id, body) => {
    return await ApiRequest.set(`v1/grants/reject-grant-payment-by-id/${id}`, "PUT", body);
  }

  static edit = async (id, body) => {
    return await ApiRequest.set(`v1/user/profile/${id}`, "PUT", body);
  }

  static delete = async (id) => {
    return await ApiRequest.set(`v1/user/${id}`, "DELETE");
  }
}
